var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-cw",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h682.7v512H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m0-1 .2.7H1L.3 0l.2.7L0 .4l-.6.4.2-.7-.5-.4h.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h768v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e814",
    d: "M0 320h768v64H0z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 13500,
    height: 9000,
    x: 2,
    y: 2,
    fill: "#fff",
    transform: "scale(42.67)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 13500,
    height: 9000,
    x: 3,
    y: 3,
    fill: "#fff",
    transform: "scale(56.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/cw.becdffe6af9758c3ee0c12a2f08c9c29.svg";
export { ForwardRef as ReactComponent };